/**
 * Mutations for updating the state via actions.
 * Names should reference from mutation types
 */

import * as types from './mutation-types';

export const mutations = {
  [types.ADD_EVENTS] (state, payload) {
    state.events = payload
  },
  [types.SET_FILTER_LIMIT](state, limit) {
		state.props.limit = limit
  },
  [types.SET_MAX_QUERY_SIZE](state, limit) {
		state.largestQuerySize = limit
	},
	[types.SET_STATUS](state, status) {
		state.status = status
	}
};
